export default "__VITE_ASSET__c6277e50__"